/**
 * True only for the loopback browser that captures public marketing pages.
 * The host check keeps a spoofed global from disabling Firebase on the real
 * application origin.
 */
export function isTrustedPrerenderSignal(hostname: string, signaled: boolean): boolean {
  return signaled && (hostname === '127.0.0.1' || hostname === 'localhost')
}

// Capture once during bootstrap. A later script cannot flip the application
// into authless prerender mode after Firebase has already initialized.
const trustedPrerenderRuntime = typeof window !== 'undefined'
  && isTrustedPrerenderSignal(
    window.location.hostname,
    (window as unknown as { __WONDERKIT_PRERENDER__?: boolean }).__WONDERKIT_PRERENDER__ === true,
  )

export function isPrerenderRuntime(): boolean {
  return trustedPrerenderRuntime
}
